export default function AppSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              随时随地，吃瓜不断
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              51吃瓜app现已覆盖iOS和Android双平台。随时随地打开手机就能看到台北娜娜最新动态、莫里秀独家合集和玩偶姐姐热门追踪。推送提醒让你不再错过任何一个爆炸性大瓜。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mb-6">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-checkbox-circle-fill"></i>
                </span>
                实时推送通知
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-checkbox-circle-fill"></i>
                </span>
                离线阅读模式
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center text-accent-500">
                  <i className="ri-checkbox-circle-fill"></i>
                </span>
                高清视频播放
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto px-6 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-white text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-apple-fill"></i>
                </span>
                App Store 下载
              </button>
              <button className="w-full sm:w-auto px-6 py-2.5 bg-secondary-500 hover:bg-secondary-600 text-white text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                  <i className="ri-android-fill"></i>
                </span>
                安卓版下载
              </button>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[420px]">
            <div className="relative">
              <div className="absolute -inset-3 rounded-2xl bg-gradient-to-br from-secondary-100/40 to-accent-100/20 blur-xl" />
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20modern%20smartphone%20mockup%20displaying%20an%20entertainment%20news%20feed%20interface%20with%20warm%20coral%20and%20golden%20accent%20colors%2C%20floating%20on%20a%20clean%20light%20gradient%20background%20with%20soft%20shadows%2C%20minimalist%20product%20presentation%20style%2C%20high%20quality%20digital%20device%20photography&width=840&height=1000&seq=app-showcase&orientation=portrait"
                alt="51吃瓜app移动端展示"
                className="relative w-full h-auto rounded-xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}